import React, {Component} from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import UserHeader from "./UserHeader";
import UserTabs from "./TabPanel";
import { encrypt , decrypt , getParams } from "../../helpers/CryptoJs";
import { changeTab,fetchUserAlbumList,deleteUserFeed } from "./../../actions/userAction"
import $ from "jquery";


class UserContainer extends Component {
    constructor(props) {
      super(props);
      
      let tab    = window.location.href.split('/')[5];
      let userID = decrypt(window.location.href.split('/')[4]);
      if(tab == undefined){
        if(this.props.is_edit == 'true'){
          tab = 3;
        }
        tab = 0;
      }
      this.state = {
        userHeaderData   : {},
        current_user_tab : parseInt(tab),
        is_edit          : this.props.is_edit,
        albumList        : [],
        totalAlbum       : 0,
        albumPagination  : 0,
        totalAlbumPage   : 0,
        uploadList       : [],
        totalUpload      : 0,
        dedicateList     : [],
        totalDedicates   : 0,
        uploadCarousal   : null,
        dedicateCarousal : false,
        lightboxOpen     : false,
        lightBoxIndex    : 0,
        albumDetailId    : 0,
        ownProfile       : false,
        userID           : userID,
        private_profile  : 'ON'
      };
      
      this.setCurrentUserTab    = this.setCurrentUserTab.bind(this);
      this.fetchUserAlbum       = this.fetchUserAlbum.bind(this);
      this.changeCarousal       = this.changeCarousal.bind(this);
      this.openDedicateLightBox = this.openDedicateLightBox.bind(this);
      this.deleteUserFeed       = this.deleteUserFeed.bind(this);
    }
    componentDidMount() {
      
      this.setCurrentUserTab(this.state.current_user_tab);
    }
    changeCarousal(activeIndex){
      this.setState({
        uploadCarousal : activeIndex
      });
    }
    deleteUserFeed(postid,feedid,feedtype){
      let param = {
        postid   : postid,
        feedid   : feedid,
        feedtype : feedtype
      };
      this.props.deleteUserFeed(param);
    }
    UNSAFE_componentWillReceiveProps(nextProps,prevProps){
     
     
      if((this.props.changetab != nextProps.changetab) && (window.location.href.split('/')[5] != undefined)){
        this.setCurrentUserTab(nextProps.changetab);
      } 

      /* if((this.state.userID != window.location.href.split('/')[4]) && (window.location.href.split('/')[5] != undefined)){
        this.setState({
          userID : decrypt(window.location.href.split('/')[4])
        })
      }  */

      if(nextProps.currentUserDetails.id == decrypt(window.location.href.split('/')[4])){
        this.setState({
          ownProfile : true
        });
      }else{
        this.setState({
          ownProfile : false
        });
      }
      if((nextProps.userFriendDetails.id != nextProps.urlId) && (this.state.current_user_tab == 1)){
        this.setState({
          current_user_tab    : 1
        });
       //  window.location.reload(false);
      }  

      if(this.state.userID != decrypt(window.location.href.split('/')[4])){
       this.setState({
          userID           : decrypt(window.location.href.split('/')[4])
        })
        //window.location.reload();
      }  
       //console.log(this.state.userID ,decrypt(window.location.href.split('/')[4]));
      if(this.state.userID != decrypt(window.location.href.split('/')[4])){
       
        this.setState({
          userID           : decrypt(window.location.href.split('/')[4])
        },function(){
          this.fetchUserAlbum();
        });
      }  

      if(this.props.deleteAlbum != nextProps.deleteAlbum){
        let matchedIndex = (nextProps.userGalleryDetails.albumList).map(function (obj) { 
          return obj.albumid; 
        }).indexOf(nextProps.deleteAlbum.post_id);
        
        if(matchedIndex >= 0){
          $('#togglediv'+nextProps.deleteAlbum.post_id).toggle();
          (nextProps.userGalleryDetails.albumList).splice(matchedIndex, 1);
        }
      }
     
      if(nextProps.userFriendDetails != this.props.userFriendDetails){
        let view = '';
        if(nextProps.currentUserDetails.id == decrypt(window.location.href.split('/')[4])){
            view = "ON"
        }else{
          if(nextProps.userFriendDetails.fetch_profile_details != undefined){
            view = nextProps.userFriendDetails.fetch_profile_details
          }else{
            view = 'OFF'
          }
        }
        this.setState({
          private_profile   : view,
          userHeaderData    : nextProps.userFriendDetails
        });
      }
      if((this.state.current_user_tab == 2) && (prevProps.userGalleryDetails !== nextProps.userGalleryDetails)){
        this.setState({
          albumList       : nextProps.userGalleryDetails.albumList,
          totalAlbum      : nextProps.userGalleryDetails.totalAlbum,
          albumPagination : nextProps.userGalleryDetails.pagination,
          totalAlbumPage  : Math.ceil(nextProps.userGalleryDetails.totalAlbum / 50),
          uploadList      : nextProps.userGalleryDetails.uploadList,
          totalUpload     : nextProps.userGalleryDetails.totalUpload,
          dedicateList    : nextProps.userGalleryDetails.dedicateList,
          totalDedicates  : nextProps.userGalleryDetails.totalDedicates,
        });
      }
      
    }

    openDedicateLightBox(status,index){ 
      $(".dedicate-light-box").children("div").append( "<div>Hello</div>" );
      this.setState({
        lightboxOpen     : (this.state.lightboxOpen == true) ? false : true,
        lightBoxIndex    : index
      })
      
    }
 
  /*
    Description: Call Query to fetch User Album
  */
  fetchUserAlbum(){
    let param = { urlId      : this.state.userID,
                  pagination : this.state.albumPagination
                }
    this.props.fetchUserAlbumList(param);
  }
  /*
  Description: Set User Current Tab Value
  */
  setCurrentUserTab(currentTab){
    if(currentTab != this.state.current_user_tab){
      this.setState({   
        current_user_tab : currentTab
      },function(){
        if(this.state.current_user_tab == 2){ 
          this.fetchUserAlbum();
        }
      });
      
    }else{
      if(this.state.current_user_tab == 2){ 
        this.fetchUserAlbum();
      }
    }
     this.props.changeTab(currentTab);
  }
  render() {
    const{ urlId } = this.props;
    
    return (
      <div>
       <div className="container">
        <div className="col-lg-12">
        <UserHeader 
          user             = {this.state.userHeaderData} 
          ownProfile       = {this.state.ownProfile} 
          respondtorequest = {this.props.respondtorequest}
          unfriendrequest  = {this.props.unfriendrequest}
        />
        </div>
      </div>
    
       
          
          <UserTabs 
            galleryDetails       = {this.state} 
            setCurrentUserTab    = {this.setCurrentUserTab} 
            urlId                = {urlId} 
            activeTab            = {this.state.current_user_tab} 
            changeCarousal       = {this.changeCarousal} 
            openDedicateLightBox = {this.openDedicateLightBox}
            deleteUserFeed       = {this.deleteUserFeed}
            ownProfile           = {this.state.ownProfile}
            uploadCarousal       = {this.state.uploadCarousal}
            private_profile      = {this.state.private_profile}
         />
       
      </div>
      
    );
  }
}
const mapStateToProps = state => {
  return {
    currentUserDetails : state.login.user,
    userFriendDetails  : state.frienddetail['friendDetail'],
    userGalleryDetails : state.listusergallery,
    deleteAlbum        : state.deletefeed.deleteFeed,
    respondtorequest   : state.requestrespond.requestRespond,
    unfriendrequest    : state.unfriendrequest.requestUnfriend,
    changetab          :  state.activetab.usertabindex
  }
}
const mapDispatchToProps = dispatch => {
  return {
    changeTab          : bindActionCreators(changeTab, dispatch),
    fetchUserAlbumList : bindActionCreators(fetchUserAlbumList, dispatch),
    deleteUserFeed     : bindActionCreators(deleteUserFeed, dispatch),
  }
}
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(UserContainer);

